export default __webpack_public_path__ + "assembly1476de3e.png";